import React, { useState } from 'react';
import { Container, Row, Col, Nav, Card } from 'react-bootstrap';
import { Outlet, Link, useLocation } from 'react-router';
import { useAuth } from '../../auth/AuthContext';

const AdminDashboard = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(location.pathname.split('/admin/')[1] || 'users');

  if (!user?.isAdmin) {
    return (
      <Container className="py-4 mt-5">
        <Card className="shadow-sm">
          <Card.Body className="text-center p-5">
            <h3 className="text-danger mb-4">權限不足</h3>
            <p>您沒有瀏覽管理員後台的權限。如果您認為這是錯誤，請聯絡系統管理員。</p>
            <Link to="/" className="btn btn-primary">返回首頁</Link>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  return (
    <Container fluid className="admin-dashboard py-4 px-4 mt-5" style={{ minHeight: '100vh' }}>
      <h2 className="mb-4 text-center">管理員後台</h2>
      
      <Row className="align-items-start gx-4">
        {/* 左側側邊欄：所有寬度都顯示，支援排版收合 */}
        <Col xs={12} md={3} lg={2} className="mb-4">
          <Card className="shadow-sm">
            <Card.Header className="bg-dark text-white py-3">
              <h5 className="mb-0 text-center">管理選項</h5>
            </Card.Header>
            <Card.Body className="p-0">
              <Nav className="flex-column" activeKey={activeKey} onSelect={setActiveKey}>
                <Nav.Link 
                  as={Link} 
                  to="/admin/users" 
                  eventKey="users" 
                  className={`border-bottom px-3 py-3 ${activeKey === 'users' ? 'bg-light fw-bold' : ''}`}
                >
                  <div className="d-flex align-items-center">
                    <i className="bi bi-people-fill me-3 fs-5"></i>
                    <span>使用者管理</span>
                  </div>
                </Nav.Link>
                <Nav.Link 
                  as={Link} 
                  to="/admin/subscriptions" 
                  eventKey="subscriptions" 
                  className={`border-bottom px-3 py-3 ${activeKey === 'subscriptions' ? 'bg-light fw-bold' : ''}`}
                >
                  <div className="d-flex align-items-center">
                    <i className="bi bi-calendar-check me-3 fs-5"></i>
                    <span>訂閱管理</span>
                  </div>
                </Nav.Link>
                <Nav.Link 
                  as={Link} 
                  to="/admin/access" 
                  eventKey="access" 
                  className={`px-3 py-3 ${activeKey === 'access' ? 'bg-light fw-bold' : ''}`}
                >
                  <div className="d-flex align-items-center">
                    <i className="bi bi-shield-lock me-3 fs-5"></i>
                    <span>瀏覽權限管理</span>
                  </div>
                </Nav.Link>
              </Nav>
            </Card.Body>
          </Card>
        </Col>

        {/* 右側主要內容區域 */}
        <Col className="align-self-start flex-grow-1" style={{ minWidth: 0 }}>
          <div className="admin-content-wrapper" style={{ minWidth: 0, overflowX: 'auto' }}>
            <Outlet />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;